import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import { WapiService } from 'wanderu-service-wapi';

import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';
import { actions as tripDataActions } from '../../appstate';

const logger = Logger.getLogger('wanderu-ducks-trips:fetchTripItinerary');

export function fetchTripItinerary(tripId) {
    return async (dispatch) => {
        dispatch(actions.startWork(tripId));

        let error;
        try {
            const response = await WapiService.getTripItinerary(tripId);

            return dispatch(tripDataActions.setTripItinerary(tripId, response.result[tripId]));
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetchTripItinerary', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(tripId, undefined, error));
        }
    };
}

const fetchTripItineraryAction = {
    fetchTripItinerary,
    ...selectors,
};

export {
    fetchTripItineraryAction,
};

export default {
    [namespace]: reducer,
};
